
<app-spinning-wheel (loadPromoItemsClicked)="loadPromoItems($event)" (winnerSaveEvent)="winnerSaved($event)"
    [regions]="regions" [promoVehicles]="vehicles" [loadingItems]="loadingPromoItems"></app-spinning-wheel>